"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const colors_1 = __importDefault(require("../../styles/colors"));
const listSizeHeight = react_native_1.Dimensions.get('screen').height;
const styles = react_native_1.StyleSheet.create({
    smallFlex: {
        flex: 0.3,
    },
    smallTopMargin: {
        marginTop: 10,
    },
    listSize: {
        height: listSizeHeight / 2.65,
    },
    bankLogo: {
        borderRadius: 0,
        backgroundColor: colors_1.default.COLOR_WHITE,
    },
});
exports.default = styles;
